import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EMarkAllAsReadNotificationActionTypes, TMarkAllAsReadNotificationSucceed } from './types';

export const markAllAsReadSucceed: () => TMarkAllAsReadNotificationSucceed =
  actionGenerator<EMarkAllAsReadNotificationActionTypes.Succeed>(EMarkAllAsReadNotificationActionTypes.Succeed);
